import React from 'react';
import { Icon } from './Icon.js';
export const IconLabelFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m14.095,4.9994l-3.92-3.547c-.67-.605-1.679-.605-2.348,0l-3.921,3.547h0c-.575.521-.905,1.264-.905,2.04v7.2106c0,1.517,1.233,2.75,2.75,2.75h6.5c1.517,0,2.75-1.233,2.75-2.75v-7.2106c0-.775-.33-1.519-.905-2.04h-.001Zm-5.095,3.0006c-.689,0-1.25-.561-1.25-1.25s.561-1.25,1.25-1.25,1.25.561,1.25,1.25-.561,1.25-1.25,1.25Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLabelFill18.js.map